import React, { useCallback, useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "../../assets/dataTable.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, endpoints } from './Config';

import Modal from 'react-modal';

import {
    reqGET,
    reqDELETE,
    set_language,
    content_language,
} from '../../Utils';
import Hosts from '../../Hosts';
import { getTokenInfo } from './../../UseToken';
import UseSidebar from './../../UseSidebar';
//import { language } from '../WEBContent/Language';
//import { language } from './Language';

import { endOfDecadeWithOptions } from "date-fns/fp";
import { language } from "./Language";
import { color } from "../WEBContent/Color";
import { icon } from '../WEBContent/Icon';
import { set } from "core-js/core/dict";

//import Hosts from '../../Hosts';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const { pathname } = useLocation();
    const [, setRefresh] = useState(0);

    const [, set_SIDE_BAR] = useState([])
    // const [permissions, set_permissions] = useState({})

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');
    const [tasks, setTasks] = useState([]);
    ///////////////////////////////////////////////////////////////////////    
    const [filteredData, setFilteredData] = useState(data);

    const [selectedButton, setSelectedButton] = useState('default');
    const [clickedHeaders, setClickedHeaders] = useState({});
    const [sortDirection, setSortDirection] = useState(true);

    const [isFilterConcluidos, setIsFilterConcluidos] = useState(false);
    const [isFilterNaoConcluidos, setIsFilterNaoConcluidos] = useState(false);
    const [isFilterExpirados, setIsFilterExpirados] = useState(false);
    const [isFilterPorExpirar, setIsFilterPorExpirar] = useState(false);
    const [isFilterReview, setIsFilterReview] = useState(false);
    const [isFilterCanceled, setIsFilterCanceled] = useState(false);

    ///////////////////////////////////////////////////////////////////////   
    const [userTypes, setUserTypes] = useState([]);
    const [colaboradores, setColaboradores] = useState([]);
    const [teamLeaders, setTeamLeaders] = useState([]);
    const [allResponsaveis, setAllResponsaveis] = useState([]);

    const [departamentos, setDepartamentos] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [nomeEmpresa, setNomeEmpresa] = useState('');
    ///////////////////////////////////////////////////////////////////////
    const [showWarning, setShowWarning] = useState(true);
    ///////////////////////////////////////////////////////////////////////
    const [profile, setProfile] = useState(null);
    const [name, setName] = useState(null);
    const [userId, setUserId] = useState(null);
    const [departamentoUser, setDepartamentoUser] = useState(null);
    const [monitoringTasks, setMonitoringTasks] = useState([]);
    const [tasksUser, setTasksUser] = useState([])
    const [departamentoUserTasks, setDepartamentoUserTasks] = useState([])
    const [combinedTasks, setCombinedTasks] = useState([])
    const [modalValidar, setModalValidar] = useState(false)
    const [modalPorValidar, setModalPorValidar] = useState(false)
    const [selectedTask, setSelectedTask] = useState(null);
    const [fotosresponsaveis, setFotosResponsaveis] = useState([])

    const handleRowClick = (id) => {
        document.getElementById('c_' + id)?.click();
    };

    const handleHeaderClick = (header) => {
        setClickedHeaders((prevState) => {
            const isNumber = !isNaN(header);

            const sortedState = Object.keys(prevState)
                .sort((a, b) => {
                    if (isNumber) {
                        return a.localeCompare(b);
                    } else {
                        return parseFloat(a) - parseFloat(b);
                    }
                })
                .reduce((acc, key) => {
                    acc[key] = prevState[key];
                    return acc;
                }, {});

            return {
                ...sortedState,
                [header]: !prevState[header],
            };
        });
    };

    const handlePrioridade = (header) => {
        setSortDirection((prevDirection) => !prevDirection);

        const normalOrder = ['Crítico', 'Urgente', 'Normal', 'Pouco Urgente', 'Não Urgente', 'Sem Prioridade'];
        const invertedOrder = ['Sem Prioridade', 'Não Urgente', 'Pouco Urgente', 'Normal', 'Urgente', 'Crítico'];

        const order = sortDirection ? normalOrder : invertedOrder;

        const sortedData = [...filteredData].sort((a, b) => {
            const priorityA = order.indexOf(a.info.prioridade?.labelPt || 'Sem Prioridade');
            const priorityB = order.indexOf(b.info.prioridade?.labelPt || 'Sem Prioridade');

            return priorityA - priorityB;
        });

        setFilteredData(sortedData);

        setClickedHeaders((prevState) => ({
            ...prevState,
            [header]: !prevState[header],
        }));
    };

    const teste = async () => {
        try {
            const ids = [1, 2, 3, 4, 5];
            const requests = ids.map(id =>
                reqGET(Hosts.SIMCore_API + '/entities/department/' + getTokenInfo().companycode + '/' + id)
            );
            const res = await Promise.all(requests);
            //console.log("Reposta", res)

            // Filtrar os colaboradores
            res.forEach((department, index) => {
                const colaboradores = department.data.filter(entidade => entidade.profile.name === 'Colaborador');
                //console.log(`Colaboradores do departamento ${ids[index]}:`);
                colaboradores.forEach(colaborador => {
                    //console.log(colaborador.info.name);
                });
            });

        } catch (error) {
            console.error("Erro ao buscar colaboradores:", error);
        }
    };

    useEffect(() => {
        const fetchTasks = async () => {
            try {
                const response = await reqGET(`${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`);
                //console.log("Ver a estrutura das tarefas", response)

                if (response?.data) {
                    const allTasks = response.data;
                    console.log('allTasks', allTasks)

                    // Filtrar as tarefas do user logado
                    const responsaveisTasks = allTasks.filter((task) =>
                        task.info.responsaveis?.some((responsavel) => responsavel.value === userId)
                    );

                    const monitoredTasks = allTasks.filter((task) =>
                        task.info.monitor?.some((monitor) => monitor.value === userId)
                    );

                    const responsaveisDepartamentoTasks = allTasks.filter((task) =>
                        departamentoUser?.some(depart => depart.id === task.info.departamentoid)
                    );

                    const combinedTasks = [...new Set([...responsaveisTasks, ...monitoredTasks, ...responsaveisDepartamentoTasks])];
                    setCombinedTasks(combinedTasks);
                    //console.log("CombinedTasks", combinedTasks)

                    // For each das tarefas, e chamar a rota para devolver as fotos const res = await reqGET(`${Hosts.SIMCore_API}/photo/${getTokenInfo().companycode }/:id`);
                    const uniqueIds = [...new Set(
                        allTasks.flatMap(task => task.info.responsaveis.map(responsavel => responsavel.value))
                    )];

                    const photosData = await Promise.all(
                        uniqueIds.map(async id => {
                            try {
                                const res = await reqGET(`${Hosts.SIMCore_API}/entities/photo/${getTokenInfo().companycode}/${id}`);
                                console.log("resposta", res)
                                return { id: id, photo: res.data }; // Armazenar ID e a resposta correspondente
                            } catch (error) {
                                console.error(`Erro ao buscar foto para o ID ${id}:`, error);
                                return null; // Retorna nulo em caso de erro
                            }
                        })
                    );

                    setFotosResponsaveis(photosData)

                    let tasksToUse = [];
                    if (profile === 'Administrador') {
                        tasksToUse = allTasks;
                        setMonitoringTasks(monitoredTasks);
                        
                    } else {
                        tasksToUse = combinedTasks;
                        setMonitoringTasks(monitoredTasks);
                        setTasksUser(responsaveisTasks);
                        setDepartamentoUserTasks(responsaveisDepartamentoTasks);
                        //setTasks(allTasks);
                        //setData(allTasks);
                    }

                    // Ordenar as tarefas por prioridade
                    const order = ['Crítico', 'Urgente', 'Normal', 'Pouco Urgente', 'Não Urgente', 'Sem Prioridade'];
                    const sortedTasks = [...tasksToUse].sort((a, b) => {
                        const priorityA = order.indexOf(a.info.prioridade?.labelPt);
                        const priorityB = order.indexOf(b.info.prioridade?.labelPt);
                        const priorityComparison = priorityA - priorityB;

                        if (priorityComparison !== 0) {
                            return priorityComparison;
                        }

                        // In case of a tie, sort by the deadline
                        return new Date(a.data_limite || 0) - new Date(b.data_limite || 0);
                    });

                    // Set the sorted data in filteredData
                    setFilteredData(sortedTasks);
                } else {
                    console.log('Nenhum dado de tasks foi retornado.');
                }
            } catch (error) {
                console.error('Erro ao buscar as tasks:', error);
            }
        };

        fetchTasks();
    }, [userId, profile]);

    ///////////////////////////////////// VALIDAR TAREFA ////////////////////////

    const validarTarefa = (taskId) => {
        const task = monitoringTasks.find(task => task.id === taskId);
        setSelectedTask(task);
        setModalValidar(true);
    };

    const porValidar = (taskId) => {
        const task = monitoringTasks.find(task => task.id === taskId);
        setSelectedTask(task);
        setModalPorValidar(true);
    };

    const fechaModalValidar = () => {
        setModalValidar(false);
        setSelectedTask(null);
    };

    const fechaModalPorValidar = () => {
        setModalPorValidar(false);
        setSelectedTask(null);
    };

    ///////////////////////////////////////////////////////////////////////////


    const getEstadoStyle = (estado, lang) => {
        // Acessando o label do estado (usando a tradução de acordo com o idioma)
        const estadoLabel = lang === 'en' ? estado.labelEn : estado.labelPt;

        // Aplicando o estilo com base no label traduzido
        switch (estadoLabel) {
            case 'Concluído':
            case 'Completed':
                return { color: color.corVerde.rgb, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Verde
            case 'Em Progresso':
            case 'In Progress':
                return { color: color.corNormal.rgb, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Azul
            case 'Em Execução':
            case 'In execution':
                return { color: color.corUrgente.rgb, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Laranja
            case 'Pendente':
            case 'Pending':
                return { color: color.corCritica.rgb, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Vermelho
            case 'A Iniciar':
            case 'To Start':
                return { color: color.corAmarela.rgb3, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Amarelo
            case 'Em Revisão':
            case 'Under Review':
                return { color: color.corRoxa.rgb, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Roxo
            case 'Cancelado':
            case 'Canceled':
                return { color: color.corVermelha.rgb, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Cinza
            default:
                return { color: color.cor4.rgb, backgroundColor: color.cor3.rgb, fontWeight: '600' }; // Cinza Claro
        }
    };

    const traduzirEstadoParaEstilo = (estado, lang) => {
        const estadosMapeados = {
            en: {
                'Concluído': 'Completed',
                'Em Progresso': 'In Progress',
                'Em Execução': 'In Execution',
                'Pendente': 'Pending',
                'A Iniciar': 'To Start',
                'Em Revisão': 'Under Review',
                'Cancelado': 'Canceled',
            },
            pt: {
                'Completed': 'Concluído',
                'In Progress': 'Em Progresso',
                'In Execution': 'Em Execução',
                'Pending': 'Pendente',
                'To Start': 'A Iniciar',
                'Under Review': 'Em Revisão',
                'Canceled': 'Cancelado',
            },
        };
        return estadosMapeados[lang]?.[estado] || "Estado Desconhecido"; // Retorna um valor padrão se o estado não for encontrado
    };

    const getPrioridadeStyle = (estado) => {
        switch (estado) {
            case 'Normal':
                return { color: color.cor3.rgb, backgroundColor: color.corNormal.hexa, fontWeight: '400' } // Azul
            case 'Urgente':
            case 'Urgent':
                return { color: color.cor3.rgb, backgroundColor: color.corUrgente.hexa, fontWeight: '400' }; // Laranja Claro
            case 'Crítico':
            case 'Critical':
                return { color: color.cor3.rgb, backgroundColor: color.corCritica.rgb, fontWeight: '400' } // Vermelho Claro
            case 'Pouco Urgente':
            case 'Low Priority':
                return { color: color.cor3.rgb, backgroundColor: color.corRoxa.rgb, fontWeight: '400' } // Verde Claro
            case 'Não Urgente':
            case 'Not Urgent':
                return { color: color.cor3.rgb, backgroundColor: color.corVerde.rgb, fontWeight: '400' } // Lima
            default:
                return { color: color.cor3.rgb, backgroundColor: color.cor4.rgb, fontWeight: '400' } // Cinza
        }
    };

    const traduzirPrioridadeParaEstilo = (prioridade, lang) => {
        const prioridadesMapeadas = {
            en: {
                'Normal': 'Normal',
                'Urgent': 'Urgent',
                'Critical': 'Critical',
                'Low Priority': 'Low Priority',
                'Not Urgent': 'Not Urgent',
            },
            pt: {
                'Normal': 'Normal',
                'Urgente': 'Urgente',
                'Crítico': 'Crítico',
                'Pouco Urgente': 'Pouco Urgente',
                'Não Urgente': 'Não Urgente',
            },
        };
        return prioridadesMapeadas[lang]?.[prioridade] || "Sem Prioridade"; // Se não encontrar a prioridade, exibe "Sem Prioridade"
    };

    const tooltipStyles = {
        container: {
            position: 'relative',
            display: 'inline-block',
            cursor: 'pointer',
        },
        text: {
            visibility: 'hidden',
            backgroundColor: 'black',
            color: color.cor3.rgb,
            textAlign: 'center',
            borderRadius: '4px',
            padding: '4px 6px',
            position: 'absolute',
            bottom: '120%',
            left: '50%',
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
            zIndex: 1,
            opacity: 0,
            transition: 'opacity 0.2s ease-in-out',
            fontWeight: 'normal',
        },
        visible: {
            visibility: 'visible',
            opacity: 1,
        }
    };

    useEffect(() => {
        // Obter os dados do localStorage
        const storedData = localStorage.getItem('token');

        if (storedData) {
            // Parse do JSON para um objeto
            const data = JSON.parse(storedData);

            // Verificar a estrutura e imprimir os dados
            if (data.user_info) {
                //console.log('Token:', data.token);

                // Se não estiver aninhado duas vezes
                if (data.user_info.user_info) {
                    // Lógica se a estrutura estiver aninhada (não está claro o que fazer aqui)
                    //console.log('User info aninhado encontrado.');
                } else {
                    console.log('data', data);
                    console.log('Profile:', data.user_info.profile);
                    console.log('Id do user logado:', data.user_info.id);
                    console.log('Departamento do user logado:', data.user_info.departamento);

                    // Atualiza o estado com os dados do usuário
                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);
                    setUserId(data.user_info.id);

                    // Verifica se o usuário tem departamentos
                    if (Array.isArray(data.user_info.departamento)) {
                        setDepartamentoUser(data.user_info.departamento);
                    } else {
                        console.log('Nenhum departamento encontrado.');
                        setDepartamentoUser([]); // Garante que o estado não fique indefinido
                    }

                    setLoading(false)

                    fetchApi(data.user_info.id)
                }
            } else {
                console.log('User info não encontrado no localStorage');
            }
        } else {
            console.log('Dados não encontrados no localStorage');
        }

    }, []);

    let fetchApi = useCallback((id) => {

        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                res.data.forEach((v) => {
                    if (v.info.cfp !== undefined) {
                        v.info.cfp.forEach((v2) => {

                            v2.data_inicio.forEach((v_2) => {
                                //console.log('Array DATA INICIO: ', v_2);

                                if (v_2.estado === 'activo') {
                                    //console.log('data inicio: ', v_2.data);
                                    v2.data_inicio_activo = v_2.data;
                                }
                            })
                            v2.data_submissao.forEach((v_3) => {
                                if (v_3.estado === 'activo') {
                                    v2.data_submissao_activo = v_3.data;
                                }
                            })
                            v2.data_limite_fim.forEach((v_4) => {
                                if (v_4.estado === 'activo') {
                                    v2.data_limite_fim_activo = v_4.data;
                                }
                            })
                        })
                    }
                })

                setData(res.data);
                const ticketsResponsaveis = [];

                if (res.data && res.data.length > 0) {
                    res.data.forEach(item => {
                        const ticketId = item.id;
                        const responsaveis = item.info.responsaveis;
                        const monitor = item.info.monitor;

                        const responsaveisArray = responsaveis && Array.isArray(responsaveis) && responsaveis.length > 0
                            ? responsaveis.map(responsavel => ({
                                value: responsavel.value,
                                label: responsavel.label,
                            }))
                            : [];


                        const monitorValue = monitor && Array.isArray(monitor) && monitor.length > 0
                            ? monitor[0].value // Armazena o valor (ID) do monitor
                            : null;


                        ticketsResponsaveis.push({
                            ticketId: ticketId,
                            responsaveis: responsaveisArray,
                            monitor: monitorValue
                        });
                    });

                } else {
                    console.log("Nenhum dado encontrado.");
                }
                ///////////////////////////////////////////////////////////FUNCIONA///////////////////////
                /*    if (id) {
                       const filteredTickets = ticketsResponsaveis.filter(ticket => {
                           return ticket.responsaveis.some(responsavel => {
                               return responsavel.value === id;
                           });
                       });
   
   
   
                       // Verificar se o filtro retorna algum ticket
                       if (filteredTickets.length > 0) {
                           setFilteredTickets(filteredTickets);
                           setFilteredData(filteredTickets)
                           console.log(filteredData)
                           console.log("Tickets do user logado", filteredTickets)
                       } else {
                           setFilteredData([])
                           console.log("Nenhuma tarefa para o user logado.");
                           console.log(filteredData)
                       }
                   } else {
                       console.log("Nao temos user id.");
                   } */
                /////////////////////////////////  A DE CIMA FUNCIONA A DE BAIXO FALTA TESTAR///////
                /* 
                                if (id) {
                                    const filteredTickets = ticketsResponsaveis.filter(ticket => {
                                        // Verifica se o ID do utilizador é igual a algum responsável
                                        const isResponsavel = ticket.responsaveis.some(responsavel => {
                                            const isMatching = responsavel.value === id;
                                            if (isMatching) {
                                                console.log(`O ID ${id} é um responsável para o ticket ${ticket.ticketId}`);
                                            }
                                            return isMatching;
                                        });
                
                                        // Verifica se o ID do utilizador é igual ao monitor
                                        const isMonitor = ticket.monitor === id;
                                        if (isMonitor) {
                                            console.log(`O ID ${id} é o monitor para o ticket ${ticket.ticketId}`);
                                        }
                
                                        // Retorna true se o utilizador for responsável ou monitor
                                        return isResponsavel || isMonitor;
                                    });
                
                                    // Verificar se o filtro retorna algum ticket
                                    if (filteredTickets.length > 0) {
                                        setFilteredTickets(filteredTickets);
                                        setFilteredData(filteredTickets);
                                        console.log("Filtered Data:", filteredData);
                                        console.log("Tickets do user logado", filteredTickets);
                                    } else {
                                        setFilteredData([]);
                                        console.log("Nenhuma tarefa para o user logado.");
                                        console.log("Filtered Data:", filteredData); // Mostrando filteredData
                                    }
                                } else {
                                    console.log("Nao temos user id.");
                                } */

                const dataInicio = res.data[0].info.data_inicio
                const dataFim = res.data[0].info.data_limite
                setDataInicio(dataInicio)
                setDataFim(dataFim)
                const nomeEmpresa = res.data[0].info.nomeEmpresa;
                setNomeEmpresa(nomeEmpresa)

            })
            .catch(() => 404
                //  TODO: ENVIAR PÝGINA 404
                //alert(error)); 
            )
    }, [pathname])

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {
        const fetch_tipo_utilizadores = async () => {
            try {
                const res = await reqGET(Hosts.SIMCore_API + '/profiles/' + getTokenInfo().companycode);
                setUserTypes(res.data); // Armazena os tipos de utilizadores no estado
                //console.log("Tipos de utilizador", res.data)
            } catch (error) {
                console.error("Erro ao buscar os tipos de utilizadores:", error);
            }
        };

        /*
         const fetch_colaboradores = async () => {
             try {
                 const res = await reqGET(Hosts.SIMCore_API + '/entities/list/' + getTokenInfo().companycode + '/Colaborador');
                 const colaboradoresOptions = res.data.map(colaborador => ({
                     label: colaborador.name,
                     value: colaborador.id
                 }));
                 //console.log("Tipos de Colaboradores", res.data)
                 setColaboradores(colaboradoresOptions);
             } catch (error) {
                 console.error("Erro ao buscar os colaboradores:", error);
             }
         };    
         */

        const fetchDepartamentos = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
                if (res?.data) {
                    setDepartamentos(res.data);
                    //console.log("", res.data)
                } else {
                    console.warn("Resposta inesperada ao buscar departamentos:", res);
                }
            } catch (error) {
                console.error("Erro ao buscar os departamentos:", error);
            }
        };

        const fetchGrupos = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/intranet/groups/${getTokenInfo().companycode}`);
                if (res?.data) {
                    setGrupos(res.data);
                    console.log("Grupos", res.data)
                } else {
                    console.warn("Resposta inesperada ao buscar grupos:", res);
                }
            } catch (error) {
                console.error("Erro ao buscar os grupos:", error);
            }
        };

        const fetchTeamLeaders = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/TeamLeader`);
                //console.log('TeamLeaders', res)

                const teamLeadersOptions = res.data.map(teamLeader => ({
                    ...teamLeader
                }));

                setTeamLeaders(teamLeadersOptions);
                return teamLeadersOptions; // ✅ Retorna os dados

            } catch (error) {
                console.error("Erro ao buscar os TeamLeaders:", error);
                return []; // ✅ Retorna um array vazio em caso de erro
            }
        };

        const fetchColaboradores = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Colaborador`);
                //console.log('Colaboradores', res)

                const colaboradoresOptions = res.data.map(colaborador => ({
                    ...colaborador
                }));

                setColaboradores(colaboradoresOptions);
                return colaboradoresOptions; // ✅ Retorna os dados

            } catch (error) {
                console.error("Erro ao buscar os Colaboradores:", error);
                return []; // ✅ Retorna um array vazio em caso de erro
            }
        };

        const fetchResponsaveis = async () => {
            try {

                const teamLeadersOptions = await fetchTeamLeaders(); // ✅ Retorna um array de Team Leaders
                const colaboradoresOptions = await fetchColaboradores(); // ✅ Retorna um array de Colaboradores
                const combinedResponsaveis = [...teamLeadersOptions, ...colaboradoresOptions];

                //console.log('Responsaveis pelas Tarefas dos Departamentos', combinedResponsaveis)
                setAllResponsaveis(combinedResponsaveis);

            } catch (error) {
                console.error("Erro ao buscar os responsáveis:", error);
            }
        };

        fetch_tipo_utilizadores();
        fetchDepartamentos();
        fetchGrupos();
        fetchColaboradores();
        fetchTeamLeaders();
        fetchResponsaveis();

    }, []);

    useEffect(() => {

        (async () => {

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    /////////////////////////////////////////////////////////////////////////////////// 

    useEffect(() => {
        teste()
        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        //fetchApi();
        setShowWarning(true);
        setFilteredData(data);
        //console.log("data", data)

    }, [pathname]);

    /*
    useEffect(() => {
        const fetch_colaboradores = async () => {
            try {
                const res = await reqGET(Hosts.SIMCore_API + '/entities/list/' + getTokenInfo().companycode + '/Colaborador');

                const colaboradoresOptions = res.data.map(colaborador => ({
                    label: colaborador.name,
                    value: colaborador.id, // Armazena o ID (value) para comparação posterior
                    departamento: colaborador.departamento,
                    email: colaborador.email
                }));

                //  setAllResponsaveis(colaboradoresOptions);

                // Armazena um array de objetos com id e email
                const colaboradoresEmailId = colaboradoresOptions.map(colaborador => ({
                    id: colaborador.value,
                    email: colaborador.email
                }));

                //  setEmailsColaboradores(colaboradoresEmailId); // Guarda no estado tanto o ID quanto o e-mail

                //  console.log("Colaboradores (com ID e Email):", colaboradoresEmailId);
            } catch (error) {
                console.error("Erro ao buscar os colaboradores:", error);
            }
        };

        fetch_colaboradores();
    }, []);
    */

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    const traduzir = (valor, traducoes, lang) => {
        if (traducoes[valor] && traducoes[valor][lang]) {
            return traducoes[valor][lang];
        }

        return valor;
    };

    const calculateDeadline = (dataInicio, dataFim) => {
        const inicio = new Date(dataInicio);
        const fim = new Date(dataFim);
        const hoje = new Date();

        const diferencaDias = Math.ceil((fim - inicio) / (1000 * 60 * 60 * 24));

        if (hoje > fim) {
            const diasAtraso = Math.ceil((hoje - fim) / (1000 * 60 * 60 * 24));
            return `Atrasado em ${diasAtraso} dia${diasAtraso !== 1 ? 's' : ''}`;
        } else if (diferencaDias === 0) {
            return "Menos de um dia";
        }

        return `${diferencaDias} dia${diferencaDias !== 1 ? 's' : ''}`;
    };

    const getDeadlineStatus = (startDate, limitDate) => {
        const status = calculateDeadline(startDate, limitDate);
        return status;
    };

    const sortTasks = (tasks) => {
        const statusOrder = {
            "Atrasado": 1,
            "Menos de um dia": 2,
            "Concluída": 3
        };

        return tasks.sort((a, b) => {
            const statusA = getDeadlineStatus(a.info.data_inicio, a.info.data_limite);
            const statusB = getDeadlineStatus(b.info.data_inicio, b.info.data_limite);

            const daysA = typeof statusA === 'string' && statusA.includes('dia') ? parseInt(statusA.match(/\d+/)) : null;
            const daysB = typeof statusB === 'string' && statusB.includes('dia') ? parseInt(statusB.match(/\d+/)) : null;

            if (daysA !== null && daysB !== null) {
                return daysA - daysB;
            }

            return (statusOrder[statusA] || statusOrder["Concluída"]) - (statusOrder[statusB] || statusOrder["Concluída"]);
        });
    };

    const sortedData = sortTasks(data);

    const [lastDismissalTime, setLastDismissalTime] = useState(() => {
        const storedTime = localStorage.getItem('modalDismissedTime');
        return storedTime ? new Date(parseInt(storedTime)) : null;
    });

    useEffect(() => {
        const statusesToCheck = ["Atrasado", "Menos de um dia", "1 dia", "2 dias", "3 dias", "4 dias", "5 dias", "6 dias", "7 dias"];

        const hasTasksWithStatuses = sortedData.some(task => {
            const status = getDeadlineStatus(task.info.data_inicio, task.info.data_limite);
            return statusesToCheck.includes(status) && task.info.estado !== 'Concluído' && task.info.estado !== 'Cancelado';
        });

        if (hasTasksWithStatuses || lastDismissalTime === null) {
            setShowWarning(checkModalDismissal());
        } else {
            setShowWarning(false);
        }

        //resetModalDismissalTime();

    }, [sortedData, lastDismissalTime]);

    const checkModalDismissal = () => {
        const dismissedTime = localStorage.getItem('modalDismissedTime');
        const currentTime = new Date().getTime();

        if (!dismissedTime || (currentTime - dismissedTime) > 7200000) {
            return true;
        }
        return false;
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const resetModalDismissalTime = () => {
        localStorage.removeItem('modalDismissedTime');
        setLastDismissalTime(null);
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function apagar(id) {
        if (window.confirm(language[lang].delete_task)) {
            reqDELETE(api_crud_route, { id: id })
                .then(() => {
                    setLoading(true);
                    alert(language[lang].delete_success);
                })
                .then(() => fetchApi())
                .catch(e => alert(language[lang].delete_error))
        }
        window.location.reload();
    }

    const handleButtonClick = (buttonType) => {
        if (buttonType === selectedButton) {
            setSelectedButton('default');

            filterNaoConcluidoTasks(false);
            setIsFilterConcluidos(false);
            setIsFilterPorExpirar(false);
            setIsFilterExpirados(false);
            setIsFilterReview(false);

            setFilteredData(getTokenInfo().profile === 'Administrador' ? data : combinedTasks);
            return;
        }

        setSelectedButton(buttonType);

        switch (buttonType) {
            case 'naoConcluidos':
                filterNaoConcluidoTasks();
                setIsFilterConcluidos(false);
                setIsFilterPorExpirar(false);
                setIsFilterExpirados(false);
                setIsFilterReview(false);
                setIsFilterCanceled(false);
                break;

            case 'concluidos':
                filterConcluidoTasks();
                setIsFilterNaoConcluidos(false);
                setIsFilterPorExpirar(false);
                setIsFilterExpirados(false);
                setIsFilterReview(false);
                setIsFilterCanceled(false);
                break;

            case 'porExpirar':
                filterPorExpirarTasks();
                setIsFilterConcluidos(false);
                setIsFilterNaoConcluidos(false);
                setIsFilterExpirados(false);
                setIsFilterReview(false);
                setIsFilterCanceled(false);
                break;

            case 'expirados':
                filterExpiradosTasks();
                setIsFilterConcluidos(false);
                setIsFilterNaoConcluidos(false);
                setIsFilterPorExpirar(false);
                setIsFilterReview(false);
                setIsFilterCanceled(false);
                break;

            case 'review':
                filterReview();
                setIsFilterExpirados(false);
                setIsFilterConcluidos(false);
                setIsFilterNaoConcluidos(false);
                setIsFilterPorExpirar(false);
                setIsFilterCanceled(false);
                break;

            case 'canceled':
                filterCanceled();
                setIsFilterExpirados(false);
                setIsFilterConcluidos(false);
                setIsFilterNaoConcluidos(false);
                setIsFilterPorExpirar(false);
                setIsFilterReview(false);
                break;

            default:
                break;
        }
    };

    const getFilteredTasks = () => getTokenInfo().profile === 'Administrador' ? data : combinedTasks;

    const filterConcluidoTasks = () => {
        const concluidoTasks = isFilterConcluidos
            ? getFilteredTasks()
            : getFilteredTasks().filter(task => task.info.estado.labelPt === 'Concluído');
        setFilteredData(concluidoTasks);
        setIsFilterConcluidos(!isFilterConcluidos);
        //console.log("Tasks Validadas", concluidoTasks);
    };

    const filterNaoConcluidoTasks = () => {
        const naoConcluidoTasks = isFilterNaoConcluidos
            ? getFilteredTasks()
            : getFilteredTasks().filter(task => task.info.estado.labelPt !== 'Concluído');
        setFilteredData(naoConcluidoTasks);
        setIsFilterNaoConcluidos(!isFilterNaoConcluidos);
        //console.log("Tasks Nao Concluidas", naoConcluidoTasks);
    };

    const filterPorExpirarTasks = () => {
        const dataAtual = new Date();
        const porExpirarTasks = isFilterPorExpirar
            ? getFilteredTasks()
            : getFilteredTasks().filter(task => {
                const estado = task.info.estado.labelPt;
                const dataLimite = new Date(task.info.dataLimite);
                return (
                    estado !== 'Concluído' &&
                    estado !== 'Cancelado' &&
                    dataLimite <= dataAtual
                );
            });
        setFilteredData(porExpirarTasks);
        setIsFilterPorExpirar(!isFilterPorExpirar);
        //console.log("Por Expirar Tasks", porExpirarTasks);
    };

    const filterExpiradosTasks = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const expiradosTasks = isFilterExpirados
            ? getFilteredTasks()
            : getFilteredTasks().filter(task => {
                const dataLimite = new Date(task.info.data_limite);
                const estado = task.info.estado.labelPt;
                return estado !== 'Concluído' && dataLimite < today;
            });

        setFilteredData(expiradosTasks);
        setIsFilterExpirados(!isFilterExpirados);
        //console.log("Tasks Expiradas", expiradosTasks);
    };

    const filterReview = () => {
        const tasksReview = isFilterReview
            ? getFilteredTasks()
            : getFilteredTasks().filter(task => task.info.estado.value === 6);
        setFilteredData(tasksReview);
        setIsFilterReview(!isFilterReview);
        //console.log("Tasks Concluidas", tasksReview);
    };

    const filterCanceled = () => {
        const tasksCanceled = isFilterCanceled
            ? getFilteredTasks()
            : getFilteredTasks().filter(task => task.info.estado.value === 2);
        setFilteredData(tasksCanceled);
        setIsFilterCanceled(!isFilterCanceled);
        //console.log("Tasks Canceladas", tasksCanceled);
    };

    useEffect(() => {
        setFilteredData(getFilteredTasks());
    }, [data, combinedTasks]);

    const columns = [
        {
            name: language[lang].task_number,
            selector: 'id',
            width: '3%',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{
                        textDecoration: 'none',
                        color: 'inherit',
                    }}
                >
                    {row.id}
                </Link>
            ),
        },
        {
            width: '20%',
            name: language[lang].tarefa,
            minWidth: '100px',
            selector: 'info.name',
            sortable: true,
            left: true,
            cell: (row) => {
                const limitToTwoRows = (str) => {
                    if (str.length <= 40) return str;
                    return str.slice(0, 40) + '...';
                };

                return limitToTwoRows(row.info.name);

            },
        },
        {
            name: language[lang].tarefa_prioridade,
            selector: 'info.prioridade',
            width: '15%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
            cell: (row) => {
                const prioridade = row.info.prioridade;
                const label = prioridade
                    ? lang === 'en'
                        ? prioridade.labelEn
                        : prioridade.labelPt
                    : language[lang].no_priority;
                const labelTraduzido = traduzirPrioridadeParaEstilo(label, lang);
                const style = getPrioridadeStyle(labelTraduzido);

                return (
                    <Link
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            display: 'block',
                            padding: '0px 20px',
                            borderRadius: '20px',
                            ...style,
                        }}
                    >
                        {labelTraduzido}
                    </Link>
                );
            },
        },
        {
            width: '10%',
            name: language[lang].tarefa_resp,
            selector: 'info.responsaveis',
            sortable: false,
            left: true,
            cell: (row) => {
                const MAX_VISIBLE = 3; // Only show 3 members
                const userId = getTokenInfo().userId;

                let responsaveisList = row.info.responsaveis || [];

                if (Array.isArray(responsaveisList) && responsaveisList.length > 0) {
                    // Ensure userId is the first in the list
                    const currentUser = responsaveisList.find(responsavel => responsavel.value === userId);

                    // If the current user exists in the list, place them first
                    if (currentUser) {
                        responsaveisList = [
                            currentUser,
                            ...responsaveisList.filter(responsavel => responsavel.value !== userId)
                        ];
                    }

                    const responsaveis = (
                        <div style={{ display: 'flex', alignItems: 'center', position: 'relative', maxWidth: '150px' }}>
                            {responsaveisList.slice(0, MAX_VISIBLE).map((responsavel, index) => {
                                const photoData = fotosresponsaveis?.find(photo => photo?.id === responsavel.value);
                                //console.log("vamos ordenar por",photoData)
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '50%',
                                            overflow: 'hidden',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: photoData?.photo?.foto ? 'transparent' : '#ccc',
                                            color: '#fff',
                                            fontWeight: 'bold',
                                            fontSize: '12px',
                                            position: 'relative',
                                            marginLeft: index === 0 ? '0' : '-10px',
                                            border: '2px solid #fff'
                                        }}
                                        onMouseEnter={(e) => {
                                            const tooltip = e.currentTarget.querySelector('.tooltiptext');
                                            tooltip.style.visibility = 'visible';
                                            tooltip.style.opacity = '1';
                                        }}
                                        onMouseLeave={(e) => {
                                            const tooltip = e.currentTarget.querySelector('.tooltiptext');
                                            tooltip.style.visibility = 'hidden';
                                            tooltip.style.opacity = '0';
                                        }}
                                    >
                                        {photoData?.photo?.foto ? (
                                            <img
                                                src={photoData.photo.foto}
                                                alt={responsavel.label}
                                                style={{ width: '100%', height: '100%' }}
                                            />
                                        ) : (
                                            responsavel.label
                                                .split(' ')
                                                .map(word => word[0]?.toUpperCase())
                                                .join('')
                                                .substring(0, 2)
                                        )}

                                        <span className="tooltiptext" style={tooltipStyles.text}>
                                            {responsavel.label}
                                        </span>
                                    </div>
                                );
                            })}

                            {responsaveisList.length > MAX_VISIBLE && (
                                <div
                                    style={{
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '50%',
                                        backgroundColor: '#ddd',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        marginLeft: '-10px',
                                        border: '2px solid #fff',
                                        cursor: 'pointer',
                                        position: 'relative'
                                    }}
                                    onMouseEnter={(e) => {
                                        const tooltip = e.currentTarget.querySelector('.tooltiptext');
                                        tooltip.style.visibility = 'visible';
                                        tooltip.style.opacity = '1';
                                    }}
                                    onMouseLeave={(e) => {
                                        const tooltip = e.currentTarget.querySelector('.tooltiptext');
                                        tooltip.style.visibility = 'hidden';
                                        tooltip.style.opacity = '0';
                                    }}
                                >
                                    +{responsaveisList.length - MAX_VISIBLE}
                                    <span className="tooltiptext" style={tooltipStyles.text}>
                                        {responsaveisList.slice(MAX_VISIBLE).map(r => r.label).join(', ')}
                                    </span>
                                </div>
                            )}
                        </div>
                    );

                    return (
                        <Link
                            to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div>{responsaveis}</div>
                        </Link>
                    );
                }

                // If there are no responsible persons, just show the department icon
                const departamento = row.info.departamento;
                const departamentoData = departamentos.find(dep => dep.info.name === departamento);

                const bgColor = departamentoData?.info?.color?.primary || "#ccc"; // Default gray if no color
                const textColor = departamentoData?.info?.color?.secondary || "#fff"; // Default white if no color

                return (
                    <Link
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <span
                            style={{
                                display: "inline-block",
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                backgroundColor: bgColor,
                                color: textColor,
                                textAlign: "center",
                                lineHeight: "30px",
                                fontSize: "12px",
                                fontWeight: "bold",
                            }}
                        >
                            {departamento
                                ?.split(" ")
                                .map(word => word[0]?.toUpperCase())
                                .join("")
                                .substring(0, 2)}
                        </span>
                    </Link>
                );
            },
        },
        {
            width: '8%',
            name: language[lang].tarefa_monitor,
            selector: 'info.monitor',
            sortable: false,
            left: true,
            cell: (row) => {
                const monitors =
                    row.info.monitor &&
                        Array.isArray(row.info.monitor) &&
                        row.info.monitor.length > 0 ? (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '10px',
                            flexWrap: 'wrap',
                            maxWidth: '150px'
                        }}>
                            {row.info.monitor.map((monitor, index) => {
                                // Verificar se há uma foto para o monitor
                                const photoData = fotosresponsaveis?.find(photo => photo?.id === monitor.value);

                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        {photoData && photoData.photo && photoData.photo.foto ? (
                                            <img
                                                src={photoData.photo.foto}
                                                alt={monitor.label}
                                                style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '50%',
                                                }}
                                            />
                                        ) : (
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#ccc',
                                                    textAlign: 'center',
                                                    lineHeight: '30px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    color: '#fff',
                                                    marginRight: '10px',
                                                }}
                                            >
                                                {monitor.label
                                                    .split(' ')
                                                    .map(word => word[0]?.toUpperCase())
                                                    .join('')
                                                    .substring(0, 2)}
                                            </span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (() => {
                        const departamento = row.info.departamento;
                        const departamentoData = departamentos.find(dep => dep.info.name === departamento);

                        const bgColor = departamentoData?.info?.color?.primary || "#ccc"; // Default gray if no color
                        const textColor = departamentoData?.info?.color?.secondary || "#fff"; // Default white if no color

                        return (
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                    backgroundColor: bgColor,
                                    color: textColor,
                                    textAlign: "center",
                                    lineHeight: "30px",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                }}
                            >
                                {departamento
                                    ?.split(" ")
                                    .map(word => word[0]?.toUpperCase())
                                    .join("")
                                    .substring(0, 2)}
                            </span>
                        );
                    })();

                return (
                    <Link
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <div>{monitors}</div>
                    </Link>
                );
            },
        },
        {
            width: '9%',
            name: language[lang].data_inicio,
            selector: 'info.data_inicio',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info.data_inicio}
                </Link>
            ),
        },
        {
            width: '9%',
            name: language[lang].data_limite,
            selector: 'info.data_limite',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info.data_limite}
                </Link>
            ),
        },
        {
            width: '11%',
            name: language[lang].tarefa_estado,
            selector: 'info.estado',
            sortable: true,
            center: true,
            cell: (row) => {
                const estado = row.info.estado;
                return (
                    <Link
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            display: 'block',
                            padding: '0px 20px',
                            borderRadius: '20px',
                            ...getEstadoStyle(estado),
                        }}
                    >
                        {estado
                            ? lang === 'en'
                                ? estado.labelEn
                                : estado.labelPt
                            : 'Estado desconhecido'}
                    </Link>
                );
            },
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            cell: row => (
                <span style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '1px', width: '100%' }}>

                    {monitoringTasks.some((task) =>
                        task.id === row.id &&
                        task.info.estado === 'Concluído' &&
                        task.info.monitor.some((monitor) => monitor.value === userId || (getTokenInfo().profile === 'Administrador') || (getTokenInfo().profile === 'TeamLeader'))

                    ) ? (

                        monitoringTasks.find((task) => task.id === row.id).info.validar === true ? (
                            <button onClick={() => validarTarefa(row.id)} className="button btn-validate">
                                <img alt={language[lang].validate} src={'./img/sucesso.svg'} style={{ width: '14px', height: '14px' }} />
                                <span className="tooltiptext">{language[lang].validar_sucesso}</span>
                            </button>
                        ) : (
                            <button onClick={() => porValidar(row.id)} className="button btn-validate">
                                <img alt={language[lang].validate} src={'./img/fornecedor.svg'} style={{ width: '14px', height: '14px' }} />
                                <span className="tooltiptext">{language[lang].validar_wait}</span>
                            </button>
                        )

                    ) : null}

                    {modalValidar && (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'transparent',
                            zIndex: 1000
                        }}
                            onClick={fechaModalValidar}>
                            <div style={{
                                maxWidth: '700px',
                                width: '90%',
                                backgroundColor: color.cor3.rgb,
                                border: '0.1px solid grey',
                                borderRadius: '8px',
                                overflow: 'hidden'
                            }} onClick={(e) => e.stopPropagation()}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '15px',
                                    backgroundColor: color.cor3.rgb,
                                    borderBottom: '1px solid #ddd'
                                }}>
                                    <h5 style={{ margin: 0, fontSize: '1.25rem' }}>{language[lang].task_number}{selectedTask?.id} {language[lang].validada}</h5>
                                    <button style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '1.5rem',
                                        color: color.corCinza.rgb,
                                        cursor: 'pointer'
                                    }} onClick={fechaModalValidar}>&times;</button>
                                </div>
                                <div style={{
                                    padding: '15px',
                                    fontSize: '1rem'
                                }}>
                                    <p>{language[lang].task_sucess}</p>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    padding: '10px 15px',
                                    borderTop: '1px solid #ddd'
                                }}>
                                    <button style={{
                                        padding: '6px 12px',
                                        backgroundColor: color.corShadow.hexa,
                                        color: color.cor3.rgb,
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }} onClick={fechaModalValidar}>{language[lang].ok}</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {modalPorValidar && (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'transparent',
                            zIndex: 1000
                        }}
                            onClick={fechaModalPorValidar}>
                            <div style={{
                                maxWidth: '700px',
                                width: '90%',
                                backgroundColor: color.cor3.rgb,
                                border: '0.1px solid grey',
                                borderRadius: '8px',
                                overflow: 'hidden'
                            }} onClick={(e) => e.stopPropagation()}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '15px',
                                    backgroundColor: color.cor3.rgb,
                                    borderBottom: '1px solid #ddd'
                                }}>
                                    <h5 style={{ margin: 0, fontSize: '1.25rem' }}>{language[lang].task_number}{selectedTask?.id} {language[lang].por_validar}</h5>
                                    <button style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '1.5rem',
                                        color: color.corShadow.hexa,
                                        cursor: 'pointer'
                                    }} onClick={fechaModalPorValidar}>&times;</button>
                                </div>
                                <div style={{
                                    padding: '15px',
                                    fontSize: '1rem'
                                }}>
                                    <p>{language[lang].wait}</p>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    padding: '10px 15px',
                                    borderTop: '1px solid #ddd'
                                }}>
                                    <button style={{
                                        padding: '6px 12px',
                                        backgroundColor: color.corShadow.hexa,
                                        color: color.cor3.rgb,
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer'
                                    }} onClick={fechaModalPorValidar}>{language[lang].ok}</button>
                                </div>
                            </div>
                        </div>
                    )}

                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className={icon.view.className} style={icon.view.style}></i>
                        <span className="tooltiptext" style={{ fontSize: '12px', padding: '4px 6px' }}>{language[lang].view}</span>
                    </Link>

                    <Link className={permissions.current != null && permissions.current.edit || data.info?.monitor?.[0]?.value === userId ? "button button-update" : "d-none"} to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} replace>
                        <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        <span className="tooltiptext" style={{ fontSize: '12px', padding: '4px 6px' }}>{language[lang].edit}</span>
                    </Link>

                    {permissions.current != null && permissions.current.remove && (
                        <button onClick={() => apagar(row['id'])} className={permissions.current.remove ? "button btn-delete" : "d-none"}>
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                            <span className="tooltiptext" style={{ fontSize: '12px', padding: '4px 6px' }}>{language[lang].delete}</span>
                        </button>
                    )}

                </span>
            )
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,

    };

    const tableData = {
        columns,
        data: filteredData,
        filterPlaceholder: language[lang].filter_placeholder,
    };

    return (
        isloading ? (
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">{language[lang].loading}</h2>
                    <p>{language[lang].loading}</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
        ) : (
            <main>

                {/*
                <Modal
                    isOpen={showWarning}
                    onRequestClose={closeModal}
                    contentLabel="Task Deadline Warning"
                    style={{
                        overlay: modalStyles.modalOverlay,
                        content: modalStyles.modalContent,
                    }}
                >
                    <h2 style={modalStyles.h2Style}>Aviso!</h2>
                    {sortedData.length > 0 ? (
                        <ul style={{ ...modalStyles.pStyle, listStyleType: 'none', padding: 0 }}>
                            {sortedData.map(task => {
                                const deadlineStatus = getDeadlineStatus(task.info.data_inicio, task.info.data_limite);

                                if (task.info.estado !== 'Concluído' && task.info.estado !== 'Cancelado') {
                                    if (deadlineStatus.includes("Atrasado")) {
                                        return (
                                            <li key={task.id}>
                                                A Tarefa Nº <strong>{task.id}</strong> está <strong>{deadlineStatus}</strong>!
                                            </li>
                                        );
                                    } else if (deadlineStatus === "Menos de um dia") {
                                        return (
                                            <li key={task.id}>
                                                Faltam <strong>{deadlineStatus}</strong> para a tarefa Nº <strong>{task.id}</strong> expirar!
                                            </li>
                                        );
                                    } else if (deadlineStatus === "1 dia") {
                                        return (
                                            <li key={task.id}>
                                                Falta <strong>1 dia</strong> para a tarefa Nº <strong>{task.id}</strong> expirar!
                                            </li>
                                        );
                                    } else if (deadlineStatus.includes('dias') && parseInt(deadlineStatus) <= 7) {
                                        return (
                                            <li key={task.id}>
                                                Faltam <strong>{deadlineStatus}</strong> para a tarefa Nº <strong>{task.id}</strong> expirar!
                                            </li>
                                        );
                                    }
                                }
                                return null;
                            })}
                        </ul>
                    ) : (
                        <p style={modalStyles.pStyle}>
                            Nenhuma tarefa pendente no momento, mas fique atento para novas tarefas em breve.
                        </p>
                    )}

                    <button style={modalStyles.closeButton} onClick={closeModal}>
                        Tomei conhecimento
                    </button>

                </Modal>
               */}


                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">{language[lang].tarefa}</h2>
                    <p className="header-navigation">{language[lang].home} / {language[lang].tarefa} / {language[lang].tarefa_list}</p>
                </div>

                <div className={`dash-cards-2 body`}>
                    <div className="card">
                        <div className="div-table">
                            <div className="table-header d-flex justify-content-between align-items-center">
                                <div className="button-group-left d-flex">
                                    <button
                                        className="btn rounded-pill btn-sm py-1 px-4"
                                        onClick={() => handleButtonClick('default')}
                                        style={{
                                            color: selectedButton === 'default' ? color.corSecundaria.rgb : color.cor4.hexa,
                                            border: `1px solid ${selectedButton === 'default' ? color.corSecundaria.rgb : color.cor4.hexa}`,
                                            padding: '0.15rem 1.25rem',
                                            marginRight: '0.3rem',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {language[lang].tarefa_filtro_todas}
                                    </button>

                                    <button
                                        className="btn rounded-pill btn-sm py-1 px-4"
                                        onClick={() => handleButtonClick('naoConcluidos')}
                                        style={{
                                            color: selectedButton === 'naoConcluidos' ? color.corSecundaria.rgb : color.cor4.hexa,
                                            border: `1px solid ${selectedButton === 'naoConcluidos' ? color.corSecundaria.rgb : color.cor4.hexa}`,
                                            padding: '0.15rem 1.25rem',
                                            marginRight: '0.3rem',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {language[lang].tarefa_filtro_nao_concluidos}
                                    </button>

                                    <button
                                        className="btn rounded-pill btn-sm py-1 px-4"
                                        onClick={() => handleButtonClick('porExpirar')}
                                        style={{
                                            color: selectedButton === 'porExpirar' ? color.corSecundaria.rgb : color.cor4.hexa,
                                            border: `1px solid ${selectedButton === 'porExpirar' ? color.corSecundaria.rgb : color.cor4.hexa}`,
                                            padding: '0.15rem 1.25rem',
                                            marginRight: '0.3rem',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {language[lang].tarefa_por_expirar}
                                    </button>

                                    <button
                                        className="btn rounded-pill btn-sm py-1 px-4"
                                        onClick={() => handleButtonClick('review')}
                                        style={{
                                            color: selectedButton === 'review' ? color.corSecundaria.rgb : color.cor4.hexa,
                                            border: `1px solid ${selectedButton === 'review' ? color.corSecundaria.rgb : color.cor4.hexa}`,
                                            padding: '0.15rem 1.25rem',
                                            marginRight: '0.3rem',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {language[lang].tarefa_revisao}
                                    </button>

                                    <button
                                        className="btn rounded-pill btn-sm py-1 px-4"
                                        onClick={() => handleButtonClick('expirados')}
                                        style={{
                                            color: selectedButton === 'expirados' ? color.corSecundaria.rgb : color.cor4.hexa,
                                            border: `1px solid ${selectedButton === 'expirados' ? color.corSecundaria.rgb : color.cor4.hexa}`,
                                            padding: '0.15rem 1.25rem',
                                            marginRight: '0.3rem',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {language[lang].tarefa_expirados}
                                    </button>

                                    <button
                                        className="btn rounded-pill btn-sm py-1 px-4"
                                        onClick={() => handleButtonClick('concluidos')}
                                        style={{
                                            color: selectedButton === 'concluidos' ? color.corSecundaria.rgb : color.cor4.hexa,
                                            border: `1px solid ${selectedButton === 'concluidos' ? color.corSecundaria.rgb : color.cor4.hexa}`,
                                            padding: '0.15rem 1.25rem',
                                            marginRight: '0.3rem',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {language[lang].tarefa_filtro_concluidos}
                                    </button>

                                    <button
                                        className="btn rounded-pill btn-sm py-1 px-4"
                                        onClick={() => handleButtonClick('canceled')}
                                        style={{
                                            color: selectedButton === 'canceled' ? color.corSecundaria.rgb : color.cor4.hexa,
                                            border: `1px solid ${selectedButton === 'canceled' ? color.corSecundaria.rgb : color.cor4.hexa}`,
                                            padding: '0.15rem 1.25rem',
                                            marginRight: '0.3rem',
                                            fontSize: '0.9rem',
                                        }}
                                    >
                                        {language[lang].tarefa_filtro_canceladas}
                                    </button>
                                </div>

                                <div className="table-header d-flex justify-content-end align-items-center">
                                    {(permissions.current !== null && permissions.current.create) && (
                                        <div className="table-header text-end mb-8">
                                            <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                to={{ pathname: endpoints.regist }}
                                                style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                            >
                                                <span>{language[lang].add_new_tarefa}</span>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                               
                            </div>

                            <div className="table-body" style={{ paddingTop: '20px' }}>
                                <DataTableExtensions {...tableData}>
                                    <DataTable
                                        noDataComponent={language[lang].no_results}
                                        noHeader
                                        pagination
                                        exportHeaders
                                        paginationComponentOptions={defaultComponentOptions}
                                        paginationPerPage={25}
                                        paginationRowsPerPageOptions={[25, 50, 100]}
                                        onRowClicked={(row) => handleRowClick(row.id)}
                                        customStyles={{
                                            rows: {
                                                style: {
                                                    cursor: 'pointer',
                                                    minHeight: '24px',
                                                },
                                            },
                                            headCells: {
                                                style: {
                                                    padding: '2px',
                                                    fontSize: '12px',
                                                    //color:'red',

                                                },
                                            },
                                            cells: {
                                                style: {
                                                    //color:'red',
                                                    padding: '2px',
                                                    fontSize: '12px',
                                                },
                                            },
                                        }}
                                    />
                                </DataTableExtensions>
                            </div>
                        </div>

                    </div>
                </div>

                {/*
                {lastDismissalTime && !isNaN(lastDismissalTime.getTime()) && (
                    <h1 style={{
                        position: 'fixed',
                        right: '5%',
                        fontSize: '12px',
                        bottom: '10px',
                        color: color.corShadow.hexa,
                        fontWeight: 'normal',
                    }}>
                        {language[lang].last_notification}: {lastDismissalTime.toLocaleString()}
                    </h1>
                )}
                */}

            </main>
        )
    );
};